<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="news__background module__background"
        >
        </app-modulebackground>
        <div
            class="news__container module__container"
            v-bind:class="{ container__boxed: [1, 2, 3, 4, 5, 6].includes(module.layout.type) }"
            :data-active-brands="brands"
            :data-active-sectors="sectors"
        >
            <div class="news__inner module__inner">
                <div class="news__inner--main module__inner--main">
                    <div class="news__inner-row module__inner-row">
                        <div class="news__inner-col module__inner-col">
                            <div class="news__header module__header">
                                <h2 class="news__title module__title font-h2 color-h2">
                                    TECWORLD News
                                </h2>
                            </div>
                        </div>
                    </div>

                    <div class="news__inner-row module__inner-row">
                        <div class="news__inner-col module__inner-col">
                            <div class="news__slider module__slider">
                                <div
                                    ref="slider"
                                    class="news__list-wrap"
                                    v-bind:class="{ slider: [3].includes(module.layout.type) }"
                                >
                                    <ul
                                        class="news__list module__list"
                                        v-bind:class="{
                                            'flex--wrap': [1, 2].includes(module.layout.type)
                                        }"
                                    >
                                        <li
                                            class="news__item module__list-item dynamic-news dynamic-news--1"
                                            v-bind:class="{
                                                'col__width--one-third': [1, 2].includes(
                                                    module.layout.type
                                                ),
                                                'flex--wrap': [3].includes(module.layout.type)
                                            }"
                                        ></li>
                                        <li
                                            class="news__item module__list-item dynamic-news dynamic-news--2"
                                            v-bind:class="{
                                                'col__width--one-third': [1, 2].includes(
                                                    module.layout.type
                                                ),
                                                'flex--wrap': [3].includes(module.layout.type)
                                            }"
                                        ></li>
                                        <li
                                            class="news__item module__list-item dynamic-news dynamic-news--3"
                                            v-bind:class="{
                                                'col__width--one-third': [1, 2].includes(
                                                    module.layout.type
                                                ),
                                                'flex--wrap': [3].includes(module.layout.type)
                                            }"
                                        ></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--
                    <div class="news__inner-row module__inner-row">
                        <div class="news__inner-col module__inner-col">
                            <div class="news__cta module__cta">
                                <app-modulebutton
                                    href="https://www.tecworld.com"
                                    target="_blank"
                                    :custom-class="'news__cta-btn module__cta-btn font-button color-button bg-color-button'"
                                    >Zur TECWORLD
                                </app-modulebutton>
                            </div>
                        </div>
                    </div>
                    -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import News from '@/external/modules/News';
import { SliderMixin } from '@/mixins/SliderMixin';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebutton': ModuleButton,
        'app-modulebackground': ModuleBackground
    },
    computed: {
        ...mapGetters(['editorMode', 'getListItems']),
        brands() {
            var brandNames = this.getListItems('deha.user.misc.brands').map(function(item) {
                if (item.data && item.data.name) {
                    return item.data.name;
                }
            });
            return brandNames.join(';');
        },
        sectors() {
            var sectorsNames = this.getListItems('deha.user.misc.sectors').map(function(item) {
                if (item.data && item.data.name) {
                    return item.data.name;
                }
            });
            return sectorsNames.join(';');
        }
    },
    mounted() {
        if (this.editorMode) {
            let i = new News();
            i.init(this.$refs.root);
        }
    },
    updated() {
        if (this.editorMode) {
            let i = new News();
            i.init(this.$refs.root);
        }
    },
    methods: {},
    props: {
        module: Object
    }
};
</script>
